import { PropertiesModel } from '@common/models/PropertiesModel';
import session from '@common/session';
import create from 'zustand';

interface PropertyDashboardViewModelProps {
  pageState: 'LOADING' | 'ERROR' | 'PROPERTIES';
  position?: number | null;
}
interface PropertyDashboardViewModelActions {
  init: () => Promise<void>;
}
export const usePropertiesDashboardViewModel = create<
  PropertyDashboardViewModelProps & PropertyDashboardViewModelActions
>((set) => ({
  init: async () => {
    const investorID = session.get()?.investorId;

    // the backend determines if this investor can see any properties
    // based off criteria such as a pre-existing relationship with us.
    await PropertiesModel.getState().fetchProperties(investorID ?? null);
    set({ pageState: 'PROPERTIES' });
  },
  pageState: 'LOADING',
}));
